import IQAS from './IQAS';

export default IQAS;